import React from "react";
import styled from "styled-components";
import Card from "./Card";

function CollectionCards({ data }) {
  return (
    <Wrapper>
      {data.map((i) => (
        <Card />
      ))}
    </Wrapper>
  );
}

export default CollectionCards;
const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 12px;
`;
